import * as React from 'react';
import { theme } from '../../../theme';

interface Props {
  color?: string;
}

export const InfoIconSmall: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6683 8.50004C14.6683 4.81814 11.6835 1.83337 8.00163 1.83337C4.31973 1.83337 1.33496 4.81814 1.33496 8.50004C1.33496 12.1819 4.31973 15.1667 8.00163 15.1667C11.6835 15.1667 14.6683 12.1819 14.6683 8.50004Z"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M8.16374 11.8334V8.50004C8.16374 8.18577 8.16374 8.02864 8.06607 7.93097C7.96847 7.83337 7.81134 7.83337 7.49707 7.83337"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99707 5.83337H8.00307"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const InfoIcon: React.FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M12.2422 17V12C12.2422 11.5286 12.2422 11.2929 12.0957 11.1464C11.9493 11 11.7136 11 11.2422 11"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9922 8H12.0012"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
